(() => {
  if (window.__stickyUrgencySyncInit) return;
  window.__stickyUrgencySyncInit = true;

  const MARKER_ATTR = 'data-sticky-urgency';

  const stickyUrgency = document.createElement('div');
  stickyUrgency.className = 'globo-urgency-text globo-urgency-text--sticky';
  stickyUrgency.style.display = 'none';
  stickyUrgency.setAttribute(MARKER_ATTR, '1');

  let mountedContainer = null;
  let mountedForm = null;
  let mainUrgency = null;
  let textObserver = null;

  const getMainUrgency = () => document.querySelector('[data-globo-urgency]');

  const getUrgencyText = () => {
    if (!mainUrgency) return '';
    return (mainUrgency.textContent || '').trim();
  };

  const syncText = () => {
    const txt = getUrgencyText();
    if (!txt) {
      stickyUrgency.textContent = '';
      stickyUrgency.style.display = 'none';
      return false;
    }
    stickyUrgency.textContent = txt;
    stickyUrgency.style.display = '';
    return true;
  };

  const findStickyElements = () => {
    const container =
      document.querySelector('div[data-essential-cart-element="content-container-mobile"]') ||
      document.querySelector('div[data-essential-cart-element="content-container-desktop"]');

    const form =
      document.querySelector('form[data-essential-cart-element="essential-sticky-add-to-cart-form"]');

    if (!container || !form) return false;

    mountedContainer = container;
    mountedForm = form;
    return true;
  };

  const mount = () => {
    if (!mountedContainer || !mountedForm) return false;

    const anchor =
      mountedContainer.querySelector('[data-essential-cart-element="variant-select"]') ||
      mountedContainer.querySelector('[data-essential-cart-element="title"]');

    try {
      if (anchor) {
        if (stickyUrgency.parentNode !== mountedContainer || stickyUrgency.previousElementSibling !== anchor) {
          anchor.insertAdjacentElement('afterend', stickyUrgency);
        }
      } else {
        if (stickyUrgency.parentNode !== mountedContainer || stickyUrgency.nextElementSibling !== mountedForm) {
          mountedContainer.insertBefore(stickyUrgency, mountedForm);
        }
      }
    } catch (e) {
      return false;
    }

    syncText();
    return true;
  };

  const attachTextObserver = () => {
    if (!mainUrgency || textObserver) return;

    textObserver = new MutationObserver(() => {
      syncText();
    });

    textObserver.observe(mainUrgency, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  const init = () => {
    mainUrgency = getMainUrgency();

    if (!findStickyElements()) return false;
    if (!mainUrgency) return false;

    mount();
    attachTextObserver();
    return true;
  };

  let tries = 0;
  const boot = () => {
    tries++;
    const ok = init();
    if (!ok && tries < 40) {
      setTimeout(boot, 250);
    }
  };

  boot();
})();